"use client";


import React from "react";
import AppIcon from "../Icon";
import isNil  from "lodash/isNil";
import { cn } from "@/src/utils/functions";

interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: string;
    iconclassname?: string;
    loadingtext?: string;
    loading?: boolean;
    loadingiconclassname?: string;
    children?: React.ReactNode;
    scheme?: "primary" | "secondary" | "success" | "dark" | "danger" | undefined;
}

export default function PrimaryButton(props: PrimaryButtonProps) {
    const { type="button", disabled=false, icon=null, iconclassname="", children, className, scheme = "primary", loading=false, loadingtext, loadingiconclassname } = props;

    const _scheme:any = {
        // default: "bg-transparent text-sky- dark:text-white hover:text- disabled:hover:bg-sky-600 focus:bg-sky-500 active:bg-sky-700",
        primary: `bg-sky-600 [&.transparent]:bg-transparent text-white [&.transparent]:text-sky-600 hover:bg-sky-500 [&.transparent]:hover:text-sky-500 
                    disabled:hover:bg-sky-600 [&.transparent]:hover:bg-transparent focus:bg-sky-500 [&.transparent]:focus:bg-transparent active:bg-sky-700
                    [&.transparent]:active:bg-transparent`,
        secondary: "bg-amber-600 text-white hover:bg-amber-500 disabled:hover:bg-amber-600 focus:bg-amber-500 active:bg-amber-700",
        success: "bg-green-600 text-white hover:bg-green-500 disabled:hover:bg-green-600 focus:bg-green-500 active:bg-green-700",
        dark: `bg-gray-800 [&.transparent]:bg-transparent dark:bg-gray-800 text-white [&.transparent]:text-slate-500 dark:text-white hover:bg-gray-700 
                disabled:hover:bg-gray-800 dark:hover:bg-gray-700 focus:bg-gray-700 dark:focus:bg-white active:bg-gray-900 dark:active:bg-gray-300 focus:ring-indigo-500
                ring-offset-gray-800`,
        danger: "bg-red-600 text-white hover:bg-red-500 disabled:hover:bg-red-600 disabled:opacity-10 focus:bg-red-500 active:bg-red-700",
    }

    const _iconScheme = {
        primary: 'group-[.transparent]:text-sky-600',
        secondary: 'group-[.transparent]:text-amber-500',
        success: 'group-[.transparent]:text-green-500',
        dark: 'group-[.transparent]:text-slate-500',
        danger: 'group-[.transparent]:text-red-500',
    }

    return (
        <button 
            {...props}
            type={type}
            disabled={disabled || loading}
            className={
                cn(
                    `group inline-flex items-center justify-center border border-transparent rounded-md font-semibold text-xs lg:text-[14px]
                    focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50 [&.transparent]:disabled:opacity-50 
                    [&.transparent]:disabled:cursor-not-allowed transition ease-in-out duration-150 p-1`,
                    _scheme[scheme], 
                    className,
                )
            }
        >
                        {(icon && !loading) && (
                            <AppIcon icon={icon} className={`text-white ${_iconScheme[scheme]} ${iconclassname}`} />
                        )}
                        {loading && (
                            <svg className={`animate-spin text-white size-5 ${_iconScheme[scheme]} ${loadingiconclassname}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        )}
                        { (loading) && !isNil(loadingtext)? loadingtext : children }
        </button>
    )
}